import { Box, Typography, Button, useTheme } from "@mui/material";
import { Refresh } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { memo } from "react";

const HomeHeader = memo(({ selectedOrganisation, onRefresh }) => {
  const theme = useTheme();
  const { t } = useTranslation("common");

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      mb={3}
      sx={{
        borderRadius: 2,
        p: 3,
        background:
          theme.palette.mode === "dark"
            ? "linear-gradient(145deg, rgba(40,40,45,0.9) 0%, rgba(35,35,40,0.8) 100%)"
            : "linear-gradient(145deg, rgba(255,255,255,0.9) 0%, rgba(245,245,245,0.8) 100%)",
        backdropFilter: "blur(10px)",
        border: `1px solid ${
          theme.palette.mode === "dark"
            ? "rgba(255,255,255,0.1)"
            : "rgba(0,0,0,0.1)"
        }`,
      }}
    >
      <Box>
        <Typography
          variant="h4"
          component="h1"
          fontWeight={600}
          color={theme.palette.mode === "dark" ? "white" : "black"}
        >
          {selectedOrganisation?.name || "Dashboard Overview"}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {selectedOrganisation?.description || "Organisation"}
        </Typography>
      </Box>
      <Button
        variant="contained"
        startIcon={<Refresh />}
        onClick={onRefresh}
        sx={{
          borderRadius: 2,
          px: 3,
          py: 1.5,
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none",
          },
        }}
      >
        {t("common.refresh")}
      </Button>
    </Box>
  );
});

HomeHeader.displayName = "HomeHeader";

export default HomeHeader;
